export default "__VITE_ASSET__DSJ76r6X__"